module.exports = __webpack_public_path__ + "img/huizhangysx.17a14cda.png";